/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Announcement,
  AnnouncementPage,
  AttachmentPolicy,
  AttachmentUpload,
  BadRequestResponse,
  ConflictResponse,
  Conversation,
  ConversationPage,
  CreateAnnouncementRequest,
  CreateAttachmentRequest,
  ForbiddenResponse,
  HideMessageRequest,
  ListAnnouncementsParams,
  ListConversationsParams,
  ListMessagesParams,
  Message,
  MessagePage,
  NotFoundResponse,
  PublishAnnouncementRequest,
  SendMessageRequest,
  ServiceUnavailableResponse,
  SignedURL,
  UnauthorizedResponse,
  UnprocessableEntityResponse
} from '../model';

import { apiFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListConversationsUrl = (params?: ListConversationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/conversations?${stringifiedParams}` : `/v1/conversations`
}

/**
 * Lista as conversas do solicitante, com o nome mascarado da outra parte,
 * a ultima mensagem e o total de nao lidas.
 *
 * **Nao existe operacao de criar conversa.** A conversa nasce do vinculo:
 * quando `enrollment` cria um vinculo professor-aluno ativo, ela ja existe;
 * a conversa com o Super Admin existe para todo mundo, sempre. Uma rota de
 * criacao precisaria receber o identificador da outra pessoa, e e
 * exatamente ali que um aluno tentaria o identificador de outro aluno.
 * Sem a rota, a superficie nao existe.
 * @summary Lista as conversas do solicitante
 */
export const listConversations = async (params?: ListConversationsParams, options?: Parameters<typeof apiFetch>[1]): Promise<ConversationPage> => {

  return apiFetch<ConversationPage>(getListConversationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListConversationsQueryKey = (params?: ListConversationsParams,) => {
    return [
    `/v1/conversations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listConversations>>, TError = UnauthorizedResponse>(params?: ListConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConversationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConversations>>> = ({ signal }) => listConversations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listConversations>>>
export type ListConversationsQueryError = UnauthorizedResponse


export function useListConversations<TData = Awaited<ReturnType<typeof listConversations>>, TError = UnauthorizedResponse>(
 params: undefined |  ListConversationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConversations>>,
          TError,
          Awaited<ReturnType<typeof listConversations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConversations<TData = Awaited<ReturnType<typeof listConversations>>, TError = UnauthorizedResponse>(
 params?: ListConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConversations>>,
          TError,
          Awaited<ReturnType<typeof listConversations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConversations<TData = Awaited<ReturnType<typeof listConversations>>, TError = UnauthorizedResponse>(
 params?: ListConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as conversas do solicitante
 */

export function useListConversations<TData = Awaited<ReturnType<typeof listConversations>>, TError = UnauthorizedResponse>(
 params?: ListConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetConversationUrl = (conversationId: string,) => {




  return `/v1/conversations/${conversationId}`
}

/**
 * Detalha uma conversa. Participante e Super Admin.
 * @summary Detalha uma conversa
 */
export const getConversation = async (conversationId: string, options?: Parameters<typeof apiFetch>[1]): Promise<Conversation> => {

  return apiFetch<Conversation>(getGetConversationUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConversationQueryKey = (conversationId: string,) => {
    return [
    `/v1/conversations/${conversationId}`
    ] as const;
    }


export const getGetConversationQueryOptions = <TData = Awaited<ReturnType<typeof getConversation>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversationQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversation>>> = ({ signal }) => getConversation(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getConversation>>>
export type GetConversationQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


export function useGetConversation<TData = Awaited<ReturnType<typeof getConversation>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversation>>,
          TError,
          Awaited<ReturnType<typeof getConversation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversation<TData = Awaited<ReturnType<typeof getConversation>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversation>>,
          TError,
          Awaited<ReturnType<typeof getConversation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConversation<TData = Awaited<ReturnType<typeof getConversation>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha uma conversa
 */

export function useGetConversation<TData = Awaited<ReturnType<typeof getConversation>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConversationQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListMessagesUrl = (conversationId: string,
    params?: ListMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/conversations/${conversationId}/messages?${stringifiedParams}` : `/v1/conversations/${conversationId}/messages`
}

/**
 * Lista as mensagens de uma conversa. Participante e Super Admin. A
 * politica de retencao e de moderacao continua aberta na §15.2 e nasce
 * conservadora: nada e expurgado enquanto ela for provisoria, porque apagar
 * nao se desfaz quando a decisao real chegar.
 * @summary Lista mensagens de uma conversa
 */
export const listMessages = async (conversationId: string,
    params?: ListMessagesParams, options?: Parameters<typeof apiFetch>[1]): Promise<MessagePage> => {

  return apiFetch<MessagePage>(getListMessagesUrl(conversationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMessagesQueryKey = (conversationId: string,
    params?: ListMessagesParams,) => {
    return [
    `/v1/conversations/${conversationId}/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listMessages>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(conversationId: string,
    params?: ListMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessages>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMessagesQueryKey(conversationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMessages>>> = ({ signal }) => listMessages(conversationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listMessages>>>
export type ListMessagesQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


export function useListMessages<TData = Awaited<ReturnType<typeof listMessages>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 conversationId: string,
    params: undefined |  ListMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMessages>>,
          TError,
          Awaited<ReturnType<typeof listMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMessages<TData = Awaited<ReturnType<typeof listMessages>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 conversationId: string,
    params?: ListMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMessages>>,
          TError,
          Awaited<ReturnType<typeof listMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMessages<TData = Awaited<ReturnType<typeof listMessages>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 conversationId: string,
    params?: ListMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessages>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista mensagens de uma conversa
 */

export function useListMessages<TData = Awaited<ReturnType<typeof listMessages>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 conversationId: string,
    params?: ListMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessages>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMessagesQueryOptions(conversationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSendMessageUrl = (conversationId: string,) => {




  return `/v1/conversations/${conversationId}/messages`
}

/**
 * Envia uma mensagem na conversa. Somente participante com vinculo ativo.
 *
 * Vinculo encerrado fecha a caixa para envio e preserva o historico: a
 * leitura continua, o envio responde **409**. Os dois codigos dizem coisas
 * diferentes e a tela precisa distinguir: 409 e "sua caixa fechou", que e
 * exatamente o que `Conflict` significa — o estado atual do recurso nao
 * admite a operacao; **403 fica reservado a quem nao e participante**, e
 * essa tentativa entra na auditoria. Colapsar os dois em 403 deixaria a
 * tela sem como escrever o motivo ao lado do campo desabilitado.
 *
 * O e-mail que avisa da mensagem nova **nao reproduz o texto dela** — avisa
 * e traz o link. Reproduzir o conteudo levaria mensagem de aula para um
 * canal externo que a plataforma nao controla.
 * @summary Envia uma mensagem na conversa
 */
export const sendMessage = async (conversationId: string,
    sendMessageRequest: SendMessageRequest, options?: Parameters<typeof apiFetch>[1]): Promise<Message> => {

  return apiFetch<Message>(getSendMessageUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sendMessageRequest)
  }
);}





export const getSendMessageMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,{conversationId: string;data: SendMessageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,{conversationId: string;data: SendMessageRequest}, TContext> => {

const mutationKey = ['sendMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendMessage>>, {conversationId: string;data: SendMessageRequest}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  sendMessage(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendMessage>>>
    export type SendMessageMutationBody = SendMessageRequest
    export type SendMessageMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse

    /**
 * @summary Envia uma mensagem na conversa
 */
export const useSendMessage = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,{conversationId: string;data: SendMessageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendMessage>>,
        TError,
        {conversationId: string;data: SendMessageRequest},
        TContext
      > => {
      return useMutation(getSendMessageMutationOptions(options), queryClient);
    }
    export const getMarkMessageReadUrl = (messageId: string,) => {




  return `/v1/messages/${messageId}/read`
}

/**
 * Marca uma mensagem como lida. Somente o destinatario.
 * @summary Marca uma mensagem como lida
 */
export const markMessageRead = async (messageId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getMarkMessageReadUrl(messageId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkMessageReadMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markMessageRead>>, TError,{messageId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markMessageRead>>, TError,{messageId: string}, TContext> => {

const mutationKey = ['markMessageRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markMessageRead>>, {messageId: string}> = (props) => {
          const {messageId} = props ?? {};

          return  markMessageRead(messageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkMessageReadMutationResult = NonNullable<Awaited<ReturnType<typeof markMessageRead>>>

    export type MarkMessageReadMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse

    /**
 * @summary Marca uma mensagem como lida
 */
export const useMarkMessageRead = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markMessageRead>>, TError,{messageId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markMessageRead>>,
        TError,
        {messageId: string},
        TContext
      > => {
      return useMutation(getMarkMessageReadMutationOptions(options), queryClient);
    }
    export const getHideMessageUrl = (messageId: string,) => {




  return `/v1/messages/${messageId}`
}

/**
 * Oculta uma mensagem. A politica de moderacao continua aberta na §15.2.
 *
 * Exclusiva de Super Admin e sensivel: exige reautenticacao recente e
 * justificativa, e entra na trilha de auditoria. **Ocultar nao e apagar**:
 * a mensagem sai da caixa dos participantes e permanece no registro, com
 * autor, instante e motivo da ocultacao, porque moderacao sem trilha e
 * censura sem prova.
 * @summary Oculta uma mensagem
 */
export const hideMessage = async (messageId: string,
    hideMessageRequest: HideMessageRequest, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getHideMessageUrl(messageId),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(hideMessageRequest)
  }
);}





export const getHideMessageMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideMessage>>, TError,{messageId: string;data: HideMessageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hideMessage>>, TError,{messageId: string;data: HideMessageRequest}, TContext> => {

const mutationKey = ['hideMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hideMessage>>, {messageId: string;data: HideMessageRequest}> = (props) => {
          const {messageId,data} = props ?? {};

          return  hideMessage(messageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HideMessageMutationResult = NonNullable<Awaited<ReturnType<typeof hideMessage>>>
    export type HideMessageMutationBody = HideMessageRequest
    export type HideMessageMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse

    /**
 * @summary Oculta uma mensagem
 */
export const useHideMessage = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideMessage>>, TError,{messageId: string;data: HideMessageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hideMessage>>,
        TError,
        {messageId: string;data: HideMessageRequest},
        TContext
      > => {
      return useMutation(getHideMessageMutationOptions(options), queryClient);
    }
    export const getCreateAttachmentUploadUrl = () => {




  return `/v1/attachments`
}

/**
 * Registra um anexo e devolve a URL assinada de upload.
 *
 * A politica de anexo — tipos aceitos e limite de tamanho — continua aberta
 * na §15.2 e nasce conservadora; enquanto for provisoria, o upload responde
 * 503.
 *
 * Como nos materiais e nos comprovantes, nao ha campo de nome de arquivo
 * original: o objeto e nomeado pelo servidor e o titulo e texto que o
 * remetente escreve.
 * @summary Registra um anexo e devolve a URL de upload
 */
export const createAttachmentUpload = async (createAttachmentRequest: CreateAttachmentRequest, options?: Parameters<typeof apiFetch>[1]): Promise<AttachmentUpload> => {

  return apiFetch<AttachmentUpload>(getCreateAttachmentUploadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAttachmentRequest)
  }
);}





export const getCreateAttachmentUploadMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAttachmentUpload>>, TError,{data: CreateAttachmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAttachmentUpload>>, TError,{data: CreateAttachmentRequest}, TContext> => {

const mutationKey = ['createAttachmentUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAttachmentUpload>>, {data: CreateAttachmentRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAttachmentUpload(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAttachmentUploadMutationResult = NonNullable<Awaited<ReturnType<typeof createAttachmentUpload>>>
    export type CreateAttachmentUploadMutationBody = CreateAttachmentRequest
    export type CreateAttachmentUploadMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse | ServiceUnavailableResponse

    /**
 * @summary Registra um anexo e devolve a URL de upload
 */
export const useCreateAttachmentUpload = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAttachmentUpload>>, TError,{data: CreateAttachmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAttachmentUpload>>,
        TError,
        {data: CreateAttachmentRequest},
        TContext
      > => {
      return useMutation(getCreateAttachmentUploadMutationOptions(options), queryClient);
    }
    export const getGetAttachmentPolicyUrl = () => {




  return `/v1/attachment-policies`
}

/**
 * Le a politica de anexo vigente: tipos aceitos, limite de tamanho e se ela
 * ainda e provisoria.
 *
 * Existe porque a tela precisa validar tipo e tamanho **antes** do upload, e
 * precisa desabilitar o botao com o motivo escrito enquanto a politica for
 * provisoria. Sem esta leitura, a unica forma de a tela descobrir a politica
 * seria tentar o upload e comer um 503, que e descobrir tarde demais.
 *
 * **Nao existe `put`.** O valor esta aberto na §15.2 e e pendencia de
 * politica, nao configuracao de escola: fecha por decisao registrada, e nao
 * por alguem preencher um formulario.
 * @summary Le a politica de anexo vigente
 */
export const getAttachmentPolicy = async ( options?: Parameters<typeof apiFetch>[1]): Promise<AttachmentPolicy> => {

  return apiFetch<AttachmentPolicy>(getGetAttachmentPolicyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAttachmentPolicyQueryKey = () => {
    return [
    `/v1/attachment-policies`
    ] as const;
    }


export const getGetAttachmentPolicyQueryOptions = <TData = Awaited<ReturnType<typeof getAttachmentPolicy>>, TError = UnauthorizedResponse | ForbiddenResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentPolicy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttachmentPolicyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttachmentPolicy>>> = ({ signal }) => getAttachmentPolicy({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttachmentPolicy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttachmentPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof getAttachmentPolicy>>>
export type GetAttachmentPolicyQueryError = UnauthorizedResponse | ForbiddenResponse


export function useGetAttachmentPolicy<TData = Awaited<ReturnType<typeof getAttachmentPolicy>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentPolicy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachmentPolicy>>,
          TError,
          Awaited<ReturnType<typeof getAttachmentPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachmentPolicy<TData = Awaited<ReturnType<typeof getAttachmentPolicy>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentPolicy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttachmentPolicy>>,
          TError,
          Awaited<ReturnType<typeof getAttachmentPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttachmentPolicy<TData = Awaited<ReturnType<typeof getAttachmentPolicy>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentPolicy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Le a politica de anexo vigente
 */

export function useGetAttachmentPolicy<TData = Awaited<ReturnType<typeof getAttachmentPolicy>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachmentPolicy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttachmentPolicyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateAttachmentDownloadURLUrl = (attachmentId: string,) => {




  return `/v1/attachments/${attachmentId}/download-url`
}

/**
 * Emite uma URL assinada de curta duracao para download de um anexo.
 * Participante da conversa e Super Admin.
 * @summary Emite URL assinada de download de um anexo
 */
export const createAttachmentDownloadURL = async (attachmentId: string, options?: Parameters<typeof apiFetch>[1]): Promise<SignedURL> => {

  return apiFetch<SignedURL>(getCreateAttachmentDownloadURLUrl(attachmentId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateAttachmentDownloadURLMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAttachmentDownloadURL>>, TError,{attachmentId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAttachmentDownloadURL>>, TError,{attachmentId: string}, TContext> => {

const mutationKey = ['createAttachmentDownloadURL'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAttachmentDownloadURL>>, {attachmentId: string}> = (props) => {
          const {attachmentId} = props ?? {};

          return  createAttachmentDownloadURL(attachmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAttachmentDownloadURLMutationResult = NonNullable<Awaited<ReturnType<typeof createAttachmentDownloadURL>>>

    export type CreateAttachmentDownloadURLMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse

    /**
 * @summary Emite URL assinada de download de um anexo
 */
export const useCreateAttachmentDownloadURL = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAttachmentDownloadURL>>, TError,{attachmentId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAttachmentDownloadURL>>,
        TError,
        {attachmentId: string},
        TContext
      > => {
      return useMutation(getCreateAttachmentDownloadURLMutationOptions(options), queryClient);
    }
    export const getListAnnouncementsUrl = (params?: ListAnnouncementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/announcements?${stringifiedParams}` : `/v1/announcements`
}

/**
 * Lista os anuncios visiveis ao solicitante. A lista ja vem filtrada pelo
 * segmento a que a pessoa pertence.
 * @summary Lista anuncios visiveis ao solicitante
 */
export const listAnnouncements = async (params?: ListAnnouncementsParams, options?: Parameters<typeof apiFetch>[1]): Promise<AnnouncementPage> => {

  return apiFetch<AnnouncementPage>(getListAnnouncementsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAnnouncementsQueryKey = (params?: ListAnnouncementsParams,) => {
    return [
    `/v1/announcements`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAnnouncementsQueryOptions = <TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = UnauthorizedResponse>(params?: ListAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAnnouncementsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAnnouncements>>> = ({ signal }) => listAnnouncements(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAnnouncementsQueryResult = NonNullable<Awaited<ReturnType<typeof listAnnouncements>>>
export type ListAnnouncementsQueryError = UnauthorizedResponse


export function useListAnnouncements<TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = UnauthorizedResponse>(
 params: undefined |  ListAnnouncementsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAnnouncements>>,
          TError,
          Awaited<ReturnType<typeof listAnnouncements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnnouncements<TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = UnauthorizedResponse>(
 params?: ListAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAnnouncements>>,
          TError,
          Awaited<ReturnType<typeof listAnnouncements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnnouncements<TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = UnauthorizedResponse>(
 params?: ListAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista anuncios visiveis ao solicitante
 */

export function useListAnnouncements<TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = UnauthorizedResponse>(
 params?: ListAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAnnouncementsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateAnnouncementUrl = () => {




  return `/v1/announcements`
}

/**
 * Redige um anuncio segmentado. Exclusiva de Super Admin. Criar nao
 * publica: a publicacao e uma operacao separada, para que rascunho de
 * anuncio nao chegue a ninguem por engano.
 * @summary Redige um anuncio segmentado
 */
export const createAnnouncement = async (createAnnouncementRequest: CreateAnnouncementRequest, options?: Parameters<typeof apiFetch>[1]): Promise<Announcement> => {

  return apiFetch<Announcement>(getCreateAnnouncementUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAnnouncementRequest)
  }
);}





export const getCreateAnnouncementMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnnouncement>>, TError,{data: CreateAnnouncementRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAnnouncement>>, TError,{data: CreateAnnouncementRequest}, TContext> => {

const mutationKey = ['createAnnouncement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAnnouncement>>, {data: CreateAnnouncementRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAnnouncement(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAnnouncementMutationResult = NonNullable<Awaited<ReturnType<typeof createAnnouncement>>>
    export type CreateAnnouncementMutationBody = CreateAnnouncementRequest
    export type CreateAnnouncementMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse

    /**
 * @summary Redige um anuncio segmentado
 */
export const useCreateAnnouncement = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnnouncement>>, TError,{data: CreateAnnouncementRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAnnouncement>>,
        TError,
        {data: CreateAnnouncementRequest},
        TContext
      > => {
      return useMutation(getCreateAnnouncementMutationOptions(options), queryClient);
    }
    export const getPublishAnnouncementUrl = (announcementId: string,) => {




  return `/v1/announcements/${announcementId}/publication`
}

/**
 * Publica um anuncio para os segmentos escolhidos, materializando o publico
 * naquele instante. Exclusiva de Super Admin.
 *
 * `sendEmail` e **opcao de quem publica, desligada por padrao**, e e aqui
 * que ela entra, nao na criacao: quem decide disparar e-mail decide no
 * momento de publicar. Ligar por padrao transformaria cada aviso
 * operacional em disparo em massa, com custo e reputacao de remetente em
 * jogo.
 * @summary Publica um anuncio para o segmento escolhido
 */
export const publishAnnouncement = async (announcementId: string,
    publishAnnouncementRequest: PublishAnnouncementRequest, options?: Parameters<typeof apiFetch>[1]): Promise<Announcement> => {

  return apiFetch<Announcement>(getPublishAnnouncementUrl(announcementId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(publishAnnouncementRequest)
  }
);}





export const getPublishAnnouncementMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishAnnouncement>>, TError,{announcementId: string;data: PublishAnnouncementRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publishAnnouncement>>, TError,{announcementId: string;data: PublishAnnouncementRequest}, TContext> => {

const mutationKey = ['publishAnnouncement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishAnnouncement>>, {announcementId: string;data: PublishAnnouncementRequest}> = (props) => {
          const {announcementId,data} = props ?? {};

          return  publishAnnouncement(announcementId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishAnnouncementMutationResult = NonNullable<Awaited<ReturnType<typeof publishAnnouncement>>>
    export type PublishAnnouncementMutationBody = PublishAnnouncementRequest
    export type PublishAnnouncementMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Publica um anuncio para o segmento escolhido
 */
export const usePublishAnnouncement = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishAnnouncement>>, TError,{announcementId: string;data: PublishAnnouncementRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publishAnnouncement>>,
        TError,
        {announcementId: string;data: PublishAnnouncementRequest},
        TContext
      > => {
      return useMutation(getPublishAnnouncementMutationOptions(options), queryClient);
    }
